module.exports = __webpack_public_path__ + "img/ico-close--white.0047e226.svg";